module.exports = __webpack_public_path__ + "static/media/drawing.bdfa731e.png";